/*
 * @Descripttion:
 * @Author: 黄佳鑫
 * @Date: 2025-07-10 08:48:00
 * @LastEditors: 黄佳鑫
 * @LastEditTime: 2025-08-11 09:26:44
 */
import React from 'react'
import { Form, Row } from 'antd'
import { FormInstance } from 'antd/lib/form'
import Style from './detail.module.scss'
import moment from 'moment'
import ShowOnlyFormControl from '../../components/ShowOnlyFormControl'

interface Props {
  form: FormInstance
  isSingleSubmission?: boolean // 是否为单条提报入口进入
}

// 提报商品详情
const PersentHeaderDetail: React.FC<Props> = (props) => {
  const { form, isSingleSubmission } = props

  const formItemLayout = {
    labelCol: { span: 10 },
    wrapperCol: { span: 14 },
  }
  const itemLayou = {
    style: {
      width: '25%',
      marginBottom: '10px',
    },
  }
  return (
    <Form
      {...formItemLayout}
      form={form}
      colon={true}
      labelAlign="right"
      style={{
        margin: '10px 0 0 0',
        padding: '10px 10px 0 0',
        background: 'white',
      }}
      size="small"
    >
      {isSingleSubmission ? (
        <Row>
          <Form.Item label="项目名称" name="projectName" {...itemLayou}>
            <ShowOnlyFormControl className={Style['show-only-control']} />
          </Form.Item>
          <Form.Item label="商品编码" name="materialCode" {...itemLayou}>
            <ShowOnlyFormControl className={Style['show-only-control']} />
          </Form.Item>
          <Form.Item label="商品名称" name="materialName" {...itemLayou}>
            <ShowOnlyFormControl className={Style['show-only-control']} />
          </Form.Item>
        </Row>
      ) : (
        <Row>
          <Form.Item label="流程编码" name="reportCode" {...itemLayou}>
            <ShowOnlyFormControl className={Style['show-only-control']} />
          </Form.Item>
          <Form.Item label="项目名称" name="projectName" {...itemLayou}>
            <ShowOnlyFormControl className={Style['show-only-control']} />
          </Form.Item>
          <Form.Item label="商品编码" name="materialCode" {...itemLayou}>
            <ShowOnlyFormControl className={Style['show-only-control']} />
          </Form.Item>
          <Form.Item label="商品名称" name="materialName" {...itemLayou}>
            <ShowOnlyFormControl className={Style['show-only-control']} />
          </Form.Item>
          <Form.Item label="提报状态" name="reportStatusName" {...itemLayou}>
            <ShowOnlyFormControl className={Style['show-only-control']} />
          </Form.Item>
          <Form.Item label="提报时间" name="reportTime" {...itemLayou}>
            <ShowOnlyFormControl
              className={Style['show-only-control']}
              formatValue={(val) =>
                val && moment(val).format('YYYY-MM-DD HH:mm:ss')
              }
            />
          </Form.Item>
          <Form.Item label="审核人" name="auditUserName" {...itemLayou}>
            <ShowOnlyFormControl className={Style['show-only-control']} />
          </Form.Item>
          <Form.Item label="审核时间" name="auditTime" {...itemLayou}>
            <ShowOnlyFormControl
              className={Style['show-only-control']}
              formatValue={(val) =>
                val && moment(val).format('YYYY-MM-DD HH:mm:ss')
              }
            />
          </Form.Item>
          <Form.Item label="审核备注" name="auditRemark" {...itemLayou}>
            <ShowOnlyFormControl className={Style['show-only-control']} />
          </Form.Item>
        </Row>
      )}
    </Form>
  )
}

export default PersentHeaderDetail
/*
 * @Descripttion:
 * @Author: 黄佳鑫
 * @Date: 2025-07-10 08:48:00
 * @LastEditors: 黄佳鑫
 * @LastEditTime: 2025-08-11 09:26:44
 */
import React from 'react'
import { Form, Row } from 'antd'
import { FormInstance } from 'antd/lib/form'
import Style from './detail.module.scss'
import moment from 'moment'
import ShowOnlyFormControl from '../../components/ShowOnlyFormControl'

interface Props {
  form: FormInstance
  isSingleSubmission?: boolean // 是否为单条提报入口进入
}

// 提报商品详情
const PersentHeaderDetail: React.FC<Props> = (props) => {
  const { form, isSingleSubmission } = props

  const formItemLayout = {
    labelCol: { span: 10 },
    wrapperCol: { span: 14 },
  }
  const itemLayou = {
    style: {
      width: '25%',
      marginBottom: '10px',
    },
  }
  return (
    <Form
      {...formItemLayout}
      form={form}
      colon={true}
      labelAlign="right"
      style={{
        margin: '10px 0 0 0',
        padding: '10px 10px 0 0',
        background: 'white',
      }}
      size="small"
    >
      {isSingleSubmission ? (
        <Row>
          <Form.Item label="项目名称" name="projectName" {...itemLayou}>
            <ShowOnlyFormControl className={Style['show-only-control']} />
          </Form.Item>
          <Form.Item label="商品编码" name="materialCode" {...itemLayou}>
            <ShowOnlyFormControl className={Style['show-only-control']} />
          </Form.Item>
          <Form.Item label="商品名称" name="materialName" {...itemLayou}>
            <ShowOnlyFormControl className={Style['show-only-control']} />
          </Form.Item>
        </Row>
      ) : (
        <Row>
          <Form.Item label="流程编码" name="reportCode" {...itemLayou}>
            <ShowOnlyFormControl className={Style['show-only-control']} />
          </Form.Item>
          <Form.Item label="项目名称" name="projectName" {...itemLayou}>
            <ShowOnlyFormControl className={Style['show-only-control']} />
          </Form.Item>
          <Form.Item label="商品编码" name="materialCode" {...itemLayou}>
            <ShowOnlyFormControl className={Style['show-only-control']} />
          </Form.Item>
          <Form.Item label="商品名称" name="materialName" {...itemLayou}>
            <ShowOnlyFormControl className={Style['show-only-control']} />
          </Form.Item>
          <Form.Item label="提报状态" name="reportStatusName" {...itemLayou}>
            <ShowOnlyFormControl className={Style['show-only-control']} />
          </Form.Item>
          <Form.Item label="提报时间" name="reportTime" {...itemLayou}>
            <ShowOnlyFormControl
              className={Style['show-only-control']}
              formatValue={(val) =>
                val && moment(val).format('YYYY-MM-DD HH:mm:ss')
              }
            />
          </Form.Item>
          <Form.Item label="审核人" name="auditUserName" {...itemLayou}>
            <ShowOnlyFormControl className={Style['show-only-control']} />
          </Form.Item>
          <Form.Item label="审核时间" name="auditTime" {...itemLayou}>
            <ShowOnlyFormControl
              className={Style['show-only-control']}
              formatValue={(val) =>
                val && moment(val).format('YYYY-MM-DD HH:mm:ss')
              }
            />
          </Form.Item>
          <Form.Item label="审核备注" name="auditRemark" {...itemLayou}>
            <ShowOnlyFormControl className={Style['show-only-control']} />
          </Form.Item>
        </Row>
      )}
    </Form>
  )
}

export default PersentHeaderDetail
